export const DRILLING_LOADS_MNEMONICS = [
  'A_HKL_PU',
  'A_HKL_PU_R',
  'A_HKL_PU_P',
  'A_HKL_PU_R_P',
  'A_HKL_SO',
  'A_HKL_SO_R',
  'A_HKL_SO_P',
  'A_HKL_SO_R_P',
  'A_HKL_H_R',
  'A_HKL_H_R_P',
  'A_TQ_OFFB',
  'A_TQ_OFFB_P',
  'A_TQ_OB_P',
  'A_SPP_OFFB',
  'A_SPP_OB_RT',
  'A_SPP_OB_SL',
  'A_MFI_OFFB',
  'A_MFI_OB_RT',
  'A_MFI_OB_SL',
] as const;
